import {
  ContractOutline18Icon,
  ExpandOutline18Icon,
  TimeOutline18Icon,
} from "@vygruppen/spor-icon-react";
import { subMinutes } from "date-fns";
import { ADDITIONAL_FROM_TIME_MINUTES } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/constants";
import DecisionSupportContext from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/DecisionSupportContext";
import { FC, useContext, useMemo } from "react";
import { DropsButton, Switch, Text, tokens } from "shared/components/Spor";
import styled from "styled-components";
import { formatTimeHorizonForDisplay } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/MeasureProgress/utils";

const HeaderWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;

  height: 30px;
`;

const HeaderLeft = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  gap: ${tokens.default.size.spacing[2]};
`;

const TimeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${tokens.default.size.spacing[0.5]};
  color: ${({ theme }) => theme.colorTextSecondary};
`;

const VerticalLine = styled.div`
  width: 1px;
  height: 30px;
  background-color: ${({ theme }) => theme.colorOutlineMain};
`;

type SectionHeaderProps = {
  sectionCollapsed: boolean;
  toggleSectionCollapsed: () => void;
  isCentreSection: boolean;
  title: string;
  affectedTrainsCount?: number;
  showDeparted: boolean;
  toggleDeparted: () => void;
};

export const ActionableTrainSectionHeader: FC<SectionHeaderProps> = ({
  sectionCollapsed,
  toggleSectionCollapsed,
  isCentreSection,
  title,
  affectedTrainsCount,
  showDeparted,
  toggleDeparted,
}) => {
  const { horizonFromTime, horizonToTime } = useContext(DecisionSupportContext);

  const visibleTimePeriod = useMemo(
    () =>
      formatTimeHorizonForDisplay(
        subMinutes(horizonFromTime, ADDITIONAL_FROM_TIME_MINUTES),
        horizonToTime,
      ),
    [horizonFromTime, horizonToTime],
  );

  return (
    <HeaderWrapper>
      <HeaderLeft>
        <Text variant="md" fontWeight="bold">
          {sectionCollapsed ? "Brudd" : title}
          {affectedTrainsCount ? ` (${affectedTrainsCount})` : null}
        </Text>
      </HeaderLeft>

      <HeaderLeft>
        {!sectionCollapsed && (
          <>
            <Switch
              size="sm"
              checked={showDeparted}
              onCheckedChange={toggleDeparted}
            />

            <Text variant="sm">Vis passerte tog</Text>

            <VerticalLine />
          </>
        )}

        {isCentreSection ? (
          <DropsButton
            variant="ghost"
            size="xs"
            fontWeight="400"
            onClick={toggleSectionCollapsed}
            rightIcon={
              sectionCollapsed ? (
                <ExpandOutline18Icon />
              ) : (
                <ContractOutline18Icon />
              )
            }
          >
            {sectionCollapsed ? "" : "Komprimer"}
          </DropsButton>
        ) : (
          <TimeWrapper>
            <TimeOutline18Icon display="inline-block" /> {visibleTimePeriod}
          </TimeWrapper>
        )}
      </HeaderLeft>
    </HeaderWrapper>
  );
};
